import { createI18n } from 'vue-i18n'
import ru from '@/locales/ru.json'
import en from '@/locales/en.json'

export type MessageSchema = typeof ru

/**
 * Определение языка по приоритету:
 * 1. Сохраненный в localStorage
 * 2. Язык браузера
 * 3. Русский по умолчанию
 */
function getDefaultLocale(): string {
  const saved = localStorage.getItem('locale')
  if (saved && ['ru', 'en'].includes(saved)) return saved

  const browserLang = navigator.language.split('-')[0]
  if (browserLang && ['ru', 'en'].includes(browserLang)) return browserLang

  return 'ru'
}

const i18n = createI18n<[MessageSchema], 'ru' | 'en'>({
  legacy: false,
  locale: getDefaultLocale(),
  fallbackLocale: 'ru',
  messages: {
    ru,
    en,
  },
})

export default i18n
